import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { AxleCRMContainerComponent } from 'src/app/features/crm/container/axle-crm-container.component';
import { AxleOrgContactsPaginatorService } from 'src/app/shared/services/crm/paginator/crm.org.paginator.service';
import { AxleUserContactsPaginatorService } from 'src/app/shared/services/crm/paginator/crm.user.paginator.service';
import { ContactsStore } from 'src/app/shared/services/crm/state/crm.state';

export const clearContactsStore: CanDeactivateFn<
  AxleCRMContainerComponent
> = () => {
  const contactsStore = inject(ContactsStore);
  const userPaginatorService = inject(AxleUserContactsPaginatorService);
  const orgPaginatorService = inject(AxleOrgContactsPaginatorService);

  contactsStore.resetNewContacts();
  userPaginatorService.reset();
  orgPaginatorService.reset();

  return true;
};
